import Body from './Body/Body'
import Grid from './Grid/Grid'
import Group from './Group/Group'
import Page from './Page/Page'
import Section from './Section/Section'
import Sticky from './Sticky/Sticky'
import Title from './Title/Title'
import Wrapper from './Wrapper/Wrapper'

// Layout types
const Layout = {
  Page,
  Section,
  Grid,
  Body,
  Group,
  Title,
  Wrapper,
  Sticky
}

export default Layout
